<template>
  <of-page mode="list-form" :leftWidth="0">
    <div slot="toolBar">
      <el-button-group class="btn-oper">
        <el-button
          type="danger"
          v-access:modify
          icon="fa fa-save"
          :loading="isSave"
          @click="save"
          size="small"
        >
          保存
        </el-button>
      </el-button-group>
    </div>
    <div slot="content">
      <div class="department-detail">
        <el-form
          ref="form"
          :model="dataForm"
          label-width="120px"
          :rules="editFormRules"
        >
          <el-form-item label="一体机抬头：" prop="TopTitle" class="form-item">
            <el-input v-model="dataForm.TopTitle" style="width: 50%"></el-input>
          </el-form-item>
<!--          <el-form-item-->
<!--                  label="异常通知人员："-->
<!--                  prop="NoticePeople"-->
<!--                  class="form-item"-->
<!--          >-->
<!--            <el-select v-model="dataForm.NoticePeopleId" placeholder="请选择" @change="changePeople">-->
<!--              <el-option-->
<!--                      v-for="item in peopleList"-->
<!--                      :key="item.RealName"-->
<!--                      :label="item.RealName"-->
<!--                      :value="item.Id">-->
<!--              </el-option>-->
<!--            </el-select>-->
<!--          </el-form-item>-->
<!--          <el-form-item label="联系人手机号：" prop="MobileNo" class="form-item">-->
<!--            <el-input v-model="dataForm.MobileNo" style="width: 50%"></el-input>-->
<!--          </el-form-item>-->
          <el-form-item
            label="LOGO："
            prop="Logo"
            class="form-item"
            ref="upload1"
          >


            <el-upload
              class="upload-demo"
              drag
              :action="action"
              :on-success="handleSuccess"
              :on-preview="handlePreview"
              :on-exceed="onExceed"
              :on-remove="onRemove"
              :limit="1"
              :file-list="pictureList"
              accept="image/jpeg, image/gif, image/png, image/jpg"
              style="width: 50%"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖到此处，或<em>点击上传</em>
              </div>
              <div class="el-upload__tip" slot="tip">
                支持png/jpg/jpeg格式，建议尺寸222*63
              </div>
            </el-upload>
          </el-form-item>

          <el-form-item
            label="底部Logo："
            prop="FooterLogo"
            class="form-item"
            ref="upload3"
          >

            <el-upload
              class="upload-demo"
              drag
              :action="action"
              :on-success="handleFotterLogoSuccess"
              :on-preview="handlePreviewFotterLogo"
              :on-exceed="onExceedFotterLogo"
              :on-remove="onRemoveFotterLogo"
              :limit="1"
              :file-list="pictureList3"
              accept="image/jpeg, image/gif, image/png, image/jpg"
              style="width: 50%"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖到此处，或<em>点击上传</em>
              </div>
              <div class="el-upload__tip" slot="tip">
                支持png/jpg/jpeg格式，建议尺寸222*63
              </div>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
      <OfImageViewer
        v-if="showImageViewer"
        :imageViewerUrl="urlList"
        @closeImageViewer="closeImageViewer"
      />
    </div>
  </of-page>
</template>

<script>
import OfPage from "@/components/base/of_page/of_page";
import OfUpload from "@/components/controls/of_upload/of_upload";
import OfImageViewer from "@/components/controls/of_imageViewer";
import api from "@/modules/zjrc/api";
import store from "@/store";

export default {
  name: "dcc-online-dir-list",
  components: {
    OfPage,
    OfUpload,
    OfImageViewer,
  },
  data() {
    const checkLogo = (rule, value, callback) => {
      let vm = this;
      if (!vm.dataForm.Logo) {
        return callback(new Error("请上传图片"));
      }
      callback();
    };
    // const checkQrCode = (rule, value, callback) => {
    //   let vm = this;
    //   if (!vm.dataForm.QrCode) {
    //     return callback(new Error("请上传图片"));
    //   }
    //   callback();
    // };
    const checkFotter = (rule, value, callback) => {
      let vm = this;
      if (!vm.dataForm.FooterLogo) {
        return callback(new Error("请上传图片"));
      }
      callback();
    };
    return {
      peopleList: [],
      isLoading: false,
      dataForm: {
        TopTitle: "",
        NoticePeople: "",
      },
      isSave: false,
      editFormRules: {
        TopTitle: [
          { required: true, message: "请输入一体机抬头", trigger: "blur" },
        ],
        NoticePeople: [
          { required: true, message: "请输入异常通知人员", trigger: "change" },
        ],
        MobileNo:[
          { required: true, message: "请输入手机号码", trigger: "blur" },
        ],
        Logo: [{ required: true, validator: checkLogo, trigger: "change" }],
        // QrCode: [{ required: true, validator: checkQrCode, trigger: "change" }],
        FooterLogo: [
          { required: true, validator: checkFotter, trigger: "change" },
        ],
      },
      pictureList: [],
      pictureList2: [],
      pictureList3: [],
      limitNum: 1,
      headers: {
        "OF-Authorization": store.getters.GetUserToken,
      },
      action: "",
      urlList: [],
      showImageViewer: false,
    };
  },
  mounted() {
    const vm = this;
    vm.loadData();
   // vm.getPeople()
    vm.action = api.FileUpload;
  },
  methods: {
    changePeople(val){
      const vm = this
      vm.peopleList.map((item)=>{
        if(item.Id === val){
          vm.dataForm.NoticePeople = item.RealName
          vm.dataForm.MobileNo = item.MobileNo
        }
      })
    },
    // getPeople(){
    //   const vm = this
    //
    //   api.GetEmployee().then((rep) => {
    //     if (rep.data.Code === 0) {
    //        vm.peopleList = rep.data.Data
    //     }
    //
    //   });
    // },
    handlePreviewFotterLogo() {
      const vm = this;
      vm.urlList = [ vm.dataForm.FooterLogo];
      vm.showImageViewer = true;
    },
    onExceedFotterLogo() {
      this.$message({
        message: `只能选择 ${this.limitNum} 个文件`,
        type: "error",
      });
    },
    onRemoveFotterLogo() {
      const vm = this;
      vm.pictureList3 = [];
      vm.dataForm.FooterLogo = "";
      vm.dataForm.FotterFileId = "";
    },
    handleFotterLogoSuccess(response) {
      const vm = this;
      vm.dataForm.FotterFileId = response.Data.FileId;
      vm.dataForm.FooterLogo = "/files" + response.Data.StorePath;
    },
    handlePreviewQrCode() {
      const vm = this;
      vm.urlList = ['http://smart-zj.hsit8.com'+ vm.dataForm.QrCode];
      vm.showImageViewer = true;
    },
    onExceedQrCode() {
      this.$message({
        message: `只能选择 ${this.limitNum} 个文件`,
        type: "error",
      });
    },
    onRemoveQrCode() {
      const vm = this;
      vm.pictureList2 = [];
      vm.dataForm.QrCode = "";
      vm.dataForm.QrCodeId = "";
    },
    handleQrCodeSuccess(response) {
      const vm = this;
      vm.dataForm.QrCodeId = response.Data.FileId;
      vm.dataForm.QrCode = "/files" + response.Data.StorePath;
    },
    closeImageViewer() {
      const vm = this;
      vm.urlList = [];
      vm.showImageViewer = false;
    },
    onExceed() {
      this.$message({
        message: `只能选择 ${this.limitNum} 个文件`,
        type: "error",
      });
    },
    onRemove() {
      const vm = this;
      vm.pictureList = [];
      vm.dataForm.LogoFileId = "";
      vm.dataForm.Logo = "";
    },
    handlePreview() {
      const vm = this;


      vm.urlList = [vm.dataForm.Logo];
      vm.showImageViewer = true;
    },
    handleSuccess(response) {
      const vm = this;
      vm.dataForm.LogoFileId = response.Data.FileId;
      vm.dataForm.Logo = "/files" + response.Data.StorePath;
    },
    loadData() {
      let vm = this;
      vm.isLoading = true;
      api.GetFeatureSetting().then((rep) => {
        if (rep.data.Code === 0) {

          if (rep.data.Data != null) {
            vm.dataForm = rep.data.Data;
            vm.pictureList.push({ url: vm.dataForm.Logo, name: "logo.jpg" });
            vm.pictureList2.push({
              url: vm.dataForm.QrCode,
              name: "公众号二维码.jpg",
            });
            vm.pictureList3.push({
              url: vm.dataForm.FooterLogo,
              name: "底部Logo.jpg",
            });
          }
        }
        vm.isLoading = false;
      });
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.isSave = true;
          let params = Object.assign({}, this.dataForm);
          api
            .SaveFeatureSetting(params)
            .then((rep) => {
              this.isSave = false;
              if (rep.data.Code === 0) {
                this.$message({
                  message: "保存成功",
                  type: "success",
                });
              } else {
                this.$message({
                  message: rep.data.Message,
                  type: "error",
                });
              }
            })
            .catch((e) => {
              this.isSave = false;
              this.$message({
                message: e.toString(),
                type: "error",
              });
            });
        }
      });
    }
  }
};
</script>

<style scoped>
.department-detail > footer {
  text-align: right;
}

.box-card {
  overflow: auto;
}

.directory-node {
  font-size: 14px;
  padding-right: 8px;
}

.directory-opear {
  position: absolute;
  right: 5px;
}

.directory-opear > i:first-child {
  margin-right: 5px;
}

.directory-search {
  margin-bottom: 10px;
}

.form-item {
  height: 40px;
}

.el-date-editor >>> .el-input__icon {
  display: none;
}
</style>
<style scoped lang="scss">
/deep/ .upload-demo .el-upload input[type="file"] {
  display: none !important;
}

/deep/ .hidePic .el-upload--picture-card {
  display: none;
}
</style>
